import fetch from '../utils/fetch';
const TAG = 'API-commodity.js';
import store from '@/vuex';

export function categoryListVisibleCategory() {
  return fetch.get('/commodity/api/category/listVisibleCategory', {});
}
export function commodityKindListAllByCache() {
  return fetch.post('/commodity/api/commodityKind/listAllByCache');
}

export function commodityKindListAllByCacheV2() {
  return fetch.post('/commodity/api/commodityKind/listAllByCacheV2');
}

export function commodityDetail(goodsId) {
  // return fetch.get(`/commodity/api/commodity/detail?id=${goodsId}`);
  // 20230322增加vip橱窗图配置更改
  const memberId = store.state.memberCO.id || '';
  return fetch.get(`/newretail/api/commodity/detail?id=${goodsId}&memberId=${memberId}`);
}

export function commentListVisiblePage(
  commodityId,
  pageNo = 0,
  pageSize = 100,
  orderBy = 'create_date desc'
) {
  const postData = {
    data: { commodityId },
    orderBy,
    pageNo,
    pageSize,
  };
  return fetch.post('/commodity/api/comment/listVisiblePage', postData);
}

/**
 * 获取商详页微页面模板
 */
export function commentCountByCommodityId(commodityId) {
  return fetch.post(`/commodity/api/comment/countByCommodityId?commodityId=${commodityId}`);
}

export function categoryGetVO(id) {
  return fetch.get(`/commodity/api/category/getVO?id=${id}`);
}

export function commodityApiGetCommodityMainData(id) {
  return fetch.get(`/commodity/api/commodityApi/getCommodityMainData?id=${id}`);
}

// 根据id批量获取商品详情（券组件用到）
export function multiCommodityDetail(ids) {
  return fetch.post(`/commodity/api/commodity/listCommodityBasicByIdsAnon`, ids);
}
